import { ACCOUNT } from '../constants'
import { updateObject } from '../utils/utility';


const initialState = {
    isLoading: false,
    isSubmit: false,
    isFail: false
}

const accountReducer = (state = initialState, action) => {
    switch(action.type) {
        case ACCOUNT.REGISTER_ACCOUNT_LOAD: return registerAccountLoad(state, action);
        case ACCOUNT.REGISTER_ACCOUNT_SUCCESS: return registerAccountSuccess(state, action);
        case ACCOUNT.REGISTER_ACCOUNT_FAIL: return registerAccountFail(state, action);
        default: return state;
    }
}

const registerAccountLoad = (state, action) => {
    return updateObject(state, {isLoading: true});
}

const registerAccountSuccess = (state, action) => {
    return updateObject(state, {isLoading: false, isSubmit: true});
}

const registerAccountFail = (state, action) => {
    return updateObject(state, {isLoading: false, isFail: true});
}

export default accountReducer;